export const ENetworkElementsFields = {
	vendor: 'vendor',
	directSftp: 'directSftp',
	autoSwitch: 'autoSwitch',
	pathCu: 'pathCu',
	pathDu: 'pathDu',
	netconfPort: 'netconfPort',
	type: 'type',
	middlewareId: 'middlewareId',
	name: 'name',
	ipAddress: 'ipAddress',
	userName: 'userName',
	password: 'password',
	subscription: 'subscription',
	lastVesTimePeriod: 'lastVesTimePeriod',
	netconfCheckTimePeriod: 'netconfCheckTimePeriod',
} as const;

export const directSftpTooltips = {
	enabled: 'You will get PM files directly without receiving Netconf Events',
	disabled: 'Not supported for Benetel RUs',
};
